<template>
    <div class="check-form">
        <div class="row">
            <div class="col-md-6">
                <!-- Quilometragem -->
                <section-container
                    :title="'Km no momento do ' + (checkType === 'checkout' ? 'check-out' : 'check-in')"
                    icon="tachometer-alt"
                >
                    <div class="km-display">
                        <span class="km-value">{{ checkData.km_checkout || checkData.atual_km }}</span>
                        <span class="km-unit">km</span>
                    </div>
                </section-container>

                <!-- Combustível -->
                <fuel-level-indicator :combustible="checkData.combustible" />
                <!-- Avarias -->
                <damage-list
                    :damages="{
                        'Frontal': checkData.bkd_frontal,
                        'Lateral Direita': checkData.bkd_right_side,
                        'Traseira': checkData.bkd_rear,
                        'Lateral Esquerda': checkData.bkd_left_side,
                        'Teto': checkData.bkd_ceiling
                    }"
                />

                <!-- Observações -->
                <section-container title="Observações" icon="comment-alt" css-class="mt-4">
                    <div class="notes-container">
                        {{ checkData.notes || 'Sem observações' }}
                    </div>
                </section-container>

            </div>

            <div class="col-md-6">
                <!-- Visualização do carro -->
<!--                <damage-visualization-->
<!--                    :damage-areas="{-->
<!--                        'frontal': isAreaDamaged('bkd_frontal'),-->
<!--                        'right': isAreaDamaged('bkd_right_side'),-->
<!--                        'rear': isAreaDamaged('bkd_rear'),-->
<!--                        'left': isAreaDamaged('bkd_left_side'),-->
<!--                        'ceiling': isAreaDamaged('bkd_ceiling')-->
<!--                    }"-->
<!--                />-->


                <!-- Adicionais -->
                <additional-items
                    :checklist-items="checklistItems"
                    :selected-items="checkData.check_list"
                />

                <!-- Fotos do Veículo -->
                <vehicle-photos
                    :photos="{
                        front_photo: checkData.front_photo,
                        back_photo: checkData.back_photo,
                        left_side_photo: checkData.left_side_photo,
                        right_side_photo: checkData.right_side_photo,
                        ceiling_photo: checkData.ceiling_photo,
                        odometer_photo: checkData.odometer_photo
                    }"
                    css-class="mt-4"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SectionContainer from './SectionContainer.vue';
import FuelLevelIndicator from './FuelLevelIndicator.vue';
import DamageList from './DamageList.vue';
import AdditionalItems from './AdditionalItems.vue';
import DamageVisualization from './DamageVisualization.vue';
import VehiclePhotos from './VehiclePhotos.vue';

export default {
    name: "CheckForm",
    components: {
        SectionContainer,
        FuelLevelIndicator,
        DamageList,
        AdditionalItems,
        DamageVisualization,
        VehiclePhotos
    },
    props: {
        checkData: {
            type: Object,
            required: true
        },
        checklistItems: {
            type: Array,
            default: () => []
        },
        checkType: {
            type: String,
            default: 'checkout'
        }
    },
    methods: {
        // isAreaDamaged - verifica se uma área do veículo tem divergência
        isAreaDamaged(areaKey) {
            if (!this.checkData || !this.checkData[areaKey]) {
                return false;
            }
            return this.checkData[areaKey].divergence === 1;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/CheckForm.vue